import { DataLayer } from '@/shared/services/gtm/models/models-gtm'

type FilterApplyParams = {
    filter_id?: string
} & Record<string, unknown>

export class FilterApplyDataLayer extends DataLayer {
    public filter_id?: string

    public constructor(params: FilterApplyParams) {
        super('filter_apply')
        this.filter_id = params.filter_id
        Object.entries(params).forEach(([key, value]) => {
            if (key !== 'filter_id') {
                this[key] = value
            }
        })
    }
}
